import { BuildingStore, Building2, Crown, UserShield ,Select} from "../../ui";
import { getLocalized } from "../utils/notificationHelpers";

export default function RecipientSelector({
  restaurants,
  lang,
  t,
  state,
  setState,
  composeCategory,
}) {
  const selectedOwner = restaurants.find((owner) => owner.id === state.ownerId);
  const branchAvailable = selectedOwner?.branches?.length > 1;

  const setRecipientMode = (mode) => {
    setState((prev) => ({
      ...prev,
      recipientMode: mode,
      ownerId: "",
      ownerIds: [],
      scope: "owner",
      branchId: "",
      ownerSeesToo: true,
    }));
  };

  const setScope = (scope) => {
    setState((prev) => ({
      ...prev,
      scope,
      branchId: scope === "branch" ? prev.branchId : "",
      ownerSeesToo: scope === "branch" ? prev.ownerSeesToo : true,
    }));
  };

  const toggleOwner = (ownerId, checked) => {
    setState((prev) => ({
      ...prev,
      ownerIds: checked
        ? [...prev.ownerIds, ownerId]
        : prev.ownerIds.filter((item) => item !== ownerId),
    }));
  };

  return (
    <div className="lud-notif-recipient-selector">
      <div className="lud-notif-form-group">
        <label>{t.send.recipient}</label>
        <div className="lud-notif-toggle-row">
          <button
            type="button"
            className={state.recipientMode === "single" ? "is-active" : ""}
            onClick={() => setRecipientMode("single")}
          >
            <BuildingStore size={15} />
            {t.send.single}
          </button>
          <button
            type="button"
            className={state.recipientMode === "multiple" ? "is-active" : ""}
            onClick={() => setRecipientMode("multiple")}
          >
            <Building2 size={15} />
            {t.send.multiple}
          </button>
        </div>
      </div>

      {state.recipientMode === "single" ? (
  <div className="lud-builder-select">
    <Select
      label={t.send.recipientRestaurant}
      value={state.ownerId}
      onChange={(event) =>
        setState((prev) => ({
          ...prev,
          ownerId: event.target.value,
          scope: "owner",
          branchId: "",
          ownerSeesToo: true,
        }))
      }
      options={[
        { value: "", label: t.send.selectRestaurant },
        ...restaurants.map((owner) => ({
          value: owner.id,
          label: getLocalized(owner, "name", "nameEn", lang),
        })),
      ]}
    />
  </div>
) : (
        <div className="lud-notif-form-group">
          <label>{t.send.recipientRestaurants}</label>
          <div className="lud-notif-multi-owner-list">
            {restaurants.map((owner) => (
              <label className="lud-notif-multi-owner-item" key={owner.id}>
  <div className="lud-notif-owner-main">
    <input
      type="checkbox"
      checked={state.ownerIds.includes(owner.id)}
      onChange={(event) => toggleOwner(owner.id, event.target.checked)}
    />
    <span>{getLocalized(owner, "name", "nameEn", lang)}</span>
  </div>

  <small>{owner.branches?.length ?? 0} {t.send.branches || "فروع"}</small>
</label>
            ))}
          </div>
        </div>
      )}

      {(state.ownerId || state.recipientMode === "multiple") ? (
        <div className="lud-notif-form-group">
          <label>{t.send.scope}</label>
          <div className="lud-notif-toggle-row lud-notif-toggle-row--three">
            <button
              type="button"
              className={state.scope === "owner" ? "is-active" : ""}
              onClick={() => setScope("owner")}
            >
              <Crown size={15} />
              {t.send.ownerAndBranches}
            </button>
            <button
              type="button"
              className={state.scope === "owner-only" ? "is-active" : ""}
              onClick={() => setScope("owner-only")}
            >
              <UserShield size={15} />
              {t.send.ownerOnly}
            </button>
            {state.recipientMode === "single" && branchAvailable ? (
              <button
                type="button"
                className={state.scope === "branch" ? "is-active" : ""}
                onClick={() => setScope("branch")}
              >
                <BuildingStore size={15} />
                {t.send.branch}
              </button>
            ) : null}
          </div>
        </div>
      ) : null}

      {state.scope === "branch" ? (
  <div className="lud-builder-select">
    <Select
      label={t.send.recipientBranch}
      value={state.branchId}
      onChange={(event) =>
        setState((prev) => ({
          ...prev,
          branchId: event.target.value,
        }))
      }
      options={[
        { value: "", label: t.send.selectBranch },
        ...(selectedOwner?.branches || []).map((branch) => ({
          value: branch.id,
          label: getLocalized(branch, "name", "nameEn", lang),
        })),
      ]}
    />
  </div>
) : null}

      {state.scope === "branch" && composeCategory === "ticket" ? (
        <div className="lud-notif-form-group">
          <label>{t.send.visibility}</label>
          <label className="lud-notif-check-row">
            <input
              type="checkbox"
              checked={state.ownerSeesToo}
              onChange={(event) => setState((prev) => ({ ...prev, ownerSeesToo: event.target.checked }))}
            />
            <span>{t.send.ownerSeesToo}</span>
          </label>
          <small className="lud-notif-hint-text">{t.send.ownerSeesHint}</small>
        </div>
      ) : null}
    </div>
  );
}
